import {api, ApiResponse} from "./api";
import {Panier} from "./apiPanier";
import {Utilisateur} from "./apiUtilisateurs";

export interface Livraison {
  id: number;
	group_id: number;
	groupe_nom: string;
	date_livraison: string;
	date_livraison_display: string;
	referent: Utilisateur;
	statut: string;
	notes: string;
	paniers: Panier[];
	nb_paniers: number;
	total: number;
	poids_total: string;
	referent_nom: string;
}

export interface LivraisonRequest {
	date_livraison: string;
	group_id: number;
	referent: number;
	notes: string;
	statut: string;
}


const transformLivraison = (livraison: Livraison): Livraison => {
	return {
		...livraison,
		date_livraison_display: livraison.date_livraison ? new Date(livraison.date_livraison).toLocaleDateString('fr-FR', ) : "Non planifiée",
		nb_paniers: livraison.paniers?.length ?? 0,
		total: livraison.paniers?.reduce((total, panier) => total + panier.total, 0) ?? 0,
		referent_nom: livraison.referent?.nom_complet ?? ""
	}
}

export const getLivraisons = async (): Promise<Livraison[]> => {
  try {
    const response = await api.get<ApiResponse<Livraison[]>>('/livraisons');
    return response.data.data.map(transformLivraison);
  } catch (error) {
    console.error('Erreur lors de la récupération des livraisons:', error);
    throw error;
  }
};

export type PreparerLivraisonData = Record<string, Record<string, number>>;

export const getPreparerLivraison = async (id :number): Promise<PreparerLivraisonData> => {
	try {
		const response = await api.get<ApiResponse<PreparerLivraisonData>>(`/livraisons/preparer/${id}`);
		return response.data.data;
	} catch (error) {
		console.error('Erreur lors de la récupération des livraisons:', error);
		throw error;
	}
};
export const getLivraisonEnCours = async (id :number): Promise<Livraison> => {
	try {
		const response = await api.get<ApiResponse<Livraison>>(`/livraisons/en_cours`);
		return transformLivraison(response.data.data);
	} catch (error) {
		console.error('Erreur lors de la récupération des livraisons:', error);
		throw error;
	}
};

export const createLivraison = async (data: LivraisonRequest): Promise<Livraison> => {
	try {
		const response = await api.post<ApiResponse<Livraison>>('/livraisons', data);
		return transformLivraison(response.data.data);
	} catch (error) {
		console.error('Erreur lors de la création de la livraison:', error);
		throw error;
	}
};

export const updateLivraison = async (id: number, data: LivraisonRequest): Promise<Livraison> => {
	try {
		const response = await api.patch<ApiResponse<Livraison>>(`/livraisons/${id}`, data);
		return transformLivraison(response.data.data);
	} catch (error) {
		console.error('Erreur lors de la mise à jour de la livraison:', error);
		throw error;
	}
};

export const livraisonACreer = async (): Promise<string[]> => {
	try {
		const response = await api.get<ApiResponse<string[]>>('/livraisons/livraisons_a_creer');
		return response.data.data;
	} catch (error) {
		console.error('Erreur lors de la récupération des livraisons à créer:', error);
		throw error;
	}
}